var _style, _circle, _g, _g2, _circle2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#6DA544;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M411.9,52.9c-91.7-70.5-220.1-70.5-311.8,0L256,208.8L411.9,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,303.2L100.1,459.1c91.7,70.5,220.1,70.5,311.8,0L256,303.2L256,303.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M208.8,256L52.9,100.1c-70.5,91.7-70.5,220.1,0,311.8L208.8,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.2,256l155.9,155.9c70.5-91.7,70.5-220.1,0-311.8L303.2,256z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 111.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,178.1l9.6,16.7h19.3l-9.6,16.7l9.6,16.7h-19.3l-9.6,16.7l-9.6-16.7h-19.3l9.6-16.7l-9.6-16.7h19.3 L256,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207,256l9.6,16.7h19.3l-9.6,16.7l9.6,16.7h-19.3l-9.6,16.7l-9.6-16.7h-19.3l9.6-16.7l-9.6-16.7h19.3L207,256z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305,256l9.6,16.7h19.3l-9.6,16.7l9.6,16.7h-19.3l-9.6,16.7l-9.6-16.7h-19.3l9.6-16.7l-9.6-16.7h19.3L305,256z "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.f5c0a47422784774b877b8b9480ca904.svg";
export { ForwardRef as ReactComponent };